import logo from "./logo.png";
import bg from "./bg.jpg";
import weblogo from "./weblogo.png";
import whatsapp from './logo-whatsapp.svg'

import {
  HeartPulse,
  Phone,
} from "lucide-react";

import one from "./partners/one.jpg";
import two from "./partners/two.jpg";
import three from "./partners/three.jpg";
// import four from "./partners/four.jpg";
import five from "./partners/five.jpg";
import six from "./partners/six.jpg";
import seven from "./partners/seven.jpg";
import eight from "./partners/one.jpg";
import nine from "./partners/nine.jpg";



// import oralDiagnostics from './tracks/oral_diagnostics.jpg';
import aiOralDiagnostics from './tracks/ai_oral_diagnostics.jpg';
import oralPathophysiologyImg from './tracks/oral_pathophysiology_1_optimized.jpg';
import oralHealthImg from './tracks/oral_health_1_optimized.jpg';
import emergencyTechnologiesImg from './tracks/emergency_technologies.jpg';
import publicHealthImg from './tracks/public_health_1_optimized.jpg';
import geriatricsImg from './tracks/geriatrics_1_optimized.jpg';
import dentalMedicineImg from './tracks/dental_medicine.jpg';
import prosthodonticsImg from './tracks/prosthodontics.jpg';
import maxillofacialSurgeryImg from './tracks/maxillofacial_surgery_1_optimized.jpg';
import euroDentistryImg from './tracks/euro_dentistry.jpg';
import forensicOralImg from './tracks/forensic_oral.jpg';
import painManagementImg from './tracks/pain_management.jpg';
import pharmacologyImg from './tracks/Pharmacology_2_optimized.jpg';
import oralOncologyImg from './tracks/oral_oncology_1_optimized.jpg';
import rareDiseaseOralImg from './tracks/rare_disease_oral_1_optimized.jpg';
import remoteTreatmentImg from './tracks/Remote_treatment_1_optimized.jpg';
import oralTuberculosisImg from './tracks/oral_tuberculosis.jpg';
import digitalDentalImg from './tracks/digital_dental.jpg';
import oralCancerImg from './tracks/oral_cancer.jpg';
import nutritionalDeficiencyImg from './tracks/nutritional_deficiency_1_optimized.jpg';

import {
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Linkedin,
  // Pinterest,
  MessageCircle,
  Rss,
  Download,
  BookOpen,
  Send,
} from "lucide-react";
import { base, link } from "framer-motion/client";

//badges-------------------------------------
import silver from './badges/2.png'
import gold from './badges/3.png'
import platinum from './badges/4.png'
import section_banner from './section_banner.jpg'

// track icons------------------------------------------
import aiOral from './icons/ai_oral.png';
import oralPathophysiology from './icons/oral_pathophysiology.png';
import oralHealth from './icons/oral_health.png';
import emergencyTechnologies from './icons/emergency_technologies.png';
import publicHealth from './icons/public_health.png';
import geriatrics from './icons/geriatrics.png';
import dentalMedicine from './icons/dental_medicine.png';
import prosthodontics from './icons/prothodontics.png';
import maxillofacialSurgery from './icons/maxillofacial_surgery.png';
import euroDentistry from './icons/euro_dentistry.png';
import forensicOral from './icons/forensic_oral.png';
import painManagement from './icons/therapeutics_pain.png';
import pharmacology from './icons/pharmacology.png';
import oralOncology from './icons/oral_oncology.png';
import rareDiseaseOral from './icons/rare_disease.png';
import remoteTreatment from './icons/remote_treatment.png';
import oralTuberculosis from './icons/oral_tuberculosis.png';
import digitalDental from './icons/digital_education.png';
import oralCancer from './icons/oral_cancer.png';
import nutritionalDeficiency from './icons/nutritional_deficiency.png';

//Homepage banners------------------------------------------
import banner_one from './banners/one.jpg'
import banner_two from './banners/two.jpg'
import banner_three from './banners/three.jpg'
import banner_four from './banners/four.jpg'
import about_img from './about_img.jpg'


export const banner_images = {
  banner_four,
  banner_one,
  banner_two,
  banner_three
}





export const trackImages = {
  aiOralDiagnostics,
  oralPathophysiology: oralPathophysiologyImg,
  oralHealth: oralHealthImg,
  emergencyTechnologies: emergencyTechnologiesImg,
  publicHealth: publicHealthImg,
  geriatrics: geriatricsImg,
  dentalMedicine: dentalMedicineImg,
  prosthodontics: prosthodonticsImg,
  maxillofacialSurgery: maxillofacialSurgeryImg,
  euroDentistry: euroDentistryImg,
  forensicOral: forensicOralImg,
  painManagement: painManagementImg,
  pharmacology: pharmacologyImg,
  oralOncology: oralOncologyImg,
  rareDiseaseOral: rareDiseaseOralImg,
  remoteTreatment: remoteTreatmentImg,
  oralTuberculosis: oralTuberculosisImg,
  digitalDental: digitalDentalImg,
  oralCancer: oralCancerImg,
  nutritionalDeficiency: nutritionalDeficiencyImg,
};

export const sticky_links = [
  {
    name: "Brochure",
    icon: Download,
  },
  {
    name: "Upload Abstract",
    icon: Send,
  },
  {
    name: "42098304989",
    icon: Phone,
  },
];

export const socialLinks = [
  {
    id: 1,
    name: "Facebook",
    url: "https://www.facebook.com/people/Helix-Conference-LLC/61570321457803/",
    icon: <Facebook size={18} />,
  },
  {
    id: 2,
    name: "Twitter (X)",
    url: "https://x.com/i/flow/login?redirect_after_login=%2FHelixconfe69272",
    icon: <Twitter size={18} />,
  },
  {
    id: 3,
    name: "Instagram",
    url: "https://www.instagram.com/helixscientificconferences/",
    icon: <Instagram size={18} />,
  },
  {
    id: 4,
    name: "YouTube",
    url: "https://www.youtube.com/@Helixconferences",
    icon: <Youtube size={18} />,
  },
  {
    id: 6,
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/helix-conferences-llc/",
    icon: <Linkedin size={18} />,
  },
  {
    id: 7,
    name: "Redit",
    url: "https://www.reddit.com/user/Sufficient-Cover-471/?rdt=65190",
    icon: <Rss size={18} />, // closest match
  },
];

export const WhatsAppIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`ionicon ${className || ''}`}
    viewBox="0 0 512 512"
  >
    <path
      d="M414.73 97.1A222.14 222.14 0 00256.94 32C134 32 33.92 131.58 33.87 254a220.61 220.61 0 0029.78 111L32 480l118.25-30.87a223.63 223.63 0 00106.6 27h.09c122.93 0 223-99.59 223.06-222A220.18 220.18 0 00414.73 97.1zM256.94 438.66h-.08a185.75 185.75 0 01-94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7A183.46 183.46 0 0171.53 254c0-101.73 83.21-184.5 185.48-184.5a185 185 0 01185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 00-14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0031.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z"
      fillRule="evenodd"
    />
  </svg>
);

export {
  weblogo,
  logo,
  bg,
  silver,
  gold,
  platinum,
  about_img,
  section_banner,
  whatsapp,
  HeartPulse
};

export const tracks = [
  { name: "AI in Oral Diagnostics", icon: aiOral },
  { name: "Oral Pathophysiology & Treatment", icon: oralPathophysiology },
  { name: "Oral Health & Systemic Health", icon: oralHealth },
  { name: "Emerging Technologies", icon: emergencyTechnologies },
  { name: "Public Health", icon: publicHealth },
  { name: "Geriatrics", icon: geriatrics },
  { name: "Dental Medicine", icon: dentalMedicine },
  { name: "Prosthodontics", icon: prosthodontics },
  { name: "Maxillofacial Surgery", icon: maxillofacialSurgery },
  { name: "Euro Dentistry", icon: euroDentistry },
  { name: "Forensic Oral Medicine", icon: forensicOral },
  { name: "Therapeutics & Pain Management", icon: painManagement },
  { name: "Pharmacology", icon: pharmacology },
  { name: "Oral Oncology", icon: oralOncology },
  { name: "Rare Diseases in Oral Medicine", icon: rareDiseaseOral },
  { name: "Remote Treatment", icon: remoteTreatment },
  { name: "Oral Tuberculosis", icon: oralTuberculosis },
  { name: "Digital Dental Education", icon: digitalDental },
  { name: "Oral Cancer", icon: oralCancer },
  { name: "Nutritional Deficiencies", icon: nutritionalDeficiency },
];



// export const schedule_plan1 = [
//   {
//     time: "8:00AM - 9:00AM",
//     plan: "Breakfast",
//   },
//   {
//     time: "9:00AM - 9:30AM",
//     plan: "Registration",
//   },
//   {
//     time: "9:30AM - 9:45AM",
//     plan: "Introduction",
//   },
//   {
//     time: "9:45AM - 10:15AM",
//     plan: "KeyNote - 1",
//     note: "Slot Available",
//   },
//   {
//     time: "10:15AM - 10:45AM",
//     plan: "KeyNote - 2",
//   },
//   {
//     time: "10:45AM - 11:15AM",
//     plan: "KeyNote - 3",
//   },
//   {
//     time: "11:15AM - 11:30AM",
//     plan: "Refreshment",
//   },
//   {
//     time: "11:30AM - 11:50AM",
//     plan: "Oral Presentation - 1",
//     note: "Slot Available",
//   },
//   {
//     time: "11:50AM - 12:10PM",
//     plan: "Oral Presentation - 2",
//   },
//   {
//     time: "12:10PM - 12:30PM",
//     plan: "Oral Presentation - 3",
//   },
//   {
//     time: "12:30PM - 12:50PM",
//     plan: "Oral Presentation - 4",
//   },
//   {
//     time: "12:50PM - 1:10PM",
//     plan: "Oral Presentation - 5",
//   },
//   {
//     time: "1:10PM - 1:30PM",
//     plan: "Oral Presentation - 6",
//   },
//   {
//     time: "1:30PM - 2:00PM",
//     plan: "LUNCH",
//   },
//   {
//     time: "2:00PM - 2:20PM",
//     plan: "Oral Presentation - 7",
//   },
//   {
//     time: "2:20PM - 2:40PM",
//     plan: "Oral Presentation - 8",
//   },
//   {
//     time: "2:40PM - 3:00PM",
//     plan: "Oral Presentation - 9",
//   },
//   {
//     time: "3:00PM - 3:20PM",
//     plan: "Oral Presentation - 10",
//     note: "Slot Available",
//   },
//   {
//     time: "3:20PM - 3:40PM",
//     plan: "Oral Presentation - 11",
//   },
//   {
//     time: "3:40PM - 4:00PM",
//     plan: "Oral Presentation - 12",
//   },
//   {
//     time: "4:00PM - 4:20PM",
//     plan: "Refreshment",
//   },
//   {
//     time: "4:20PM - 4:40PM",
//     plan: "Oral Presentation - 13",
//   },
//   {
//     time: "4:40PM - 5:00PM",
//     plan: "Oral Presentation - 14",
//   },
//   {
//     time: "5:00PM - 5:20PM",
//     plan: "Oral Presentation - 15",
//   },
//   {
//     time: "5:20PM - 5:40PM",
//     plan: "Oral Presentation - 16",
//   },
//   {
//     time: "5:40PM - 6:00PM",
//     plan: "Oral Presentation - 17",
//   },
//   {
//     time: "6:00PM - 6:20PM",
//     plan: "Oral Presentation - 18",
//   },
// ];


export const schedule_plan2 = [
  {
    time: "8:00AM - 9:00AM",
    plan: "Liakou",
  },
  {
    time: "9:00AM - 9:30AM",
    plan: "Liakou",
  },
  {
    time: "9:30AM - 9:45AM",
    plan: "Liakou",
  },
  {
    time: "9:45AM - 10:15AM",
    plan: "Liakou",
  },
  {
    time: "10:15AM - 10:45AM",
    plan: "Liakou",
  },
];

export const schedule_plan3 = [
  {
    time: "8:00AM - 9:00AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "9:00AM - 9:30AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "9:30AM - 9:45AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "9:45AM - 10:15AM",
    plan: "Mohamed Hosni",
  },
  {
    time: "10:15AM - 10:45AM",
    plan: "Mohamed Hosni",
  },
];


export const venueImages = [
  {
    id: 1,
    src: "https://www.valencia-cityguide.com/images/attractions4/cac-vlc.jpg", // City of Arts and Sciences at Sunset
    alt: "City of Arts and Sciences",
  },
  {
    id: 2,
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyyqPwiciv7OKGRrG1V_BTpFhNGoC51fSJ8A&s", // Historic El Carmen District
    alt: "Valencia Cathedral",
  },
  {
    id: 3,
    src: "https://valencia.lbsfilm.at/content/images/size/w2000/2017/11/LBS_BlogOceano_048.jpg", // Oceanogràfic Aquarium
    alt: "Oceanogràfic",
  },
  {
    id: 4,
    src: "https://cdn.dreampropertiesvalencia.com/2024/12/district-el-carmen-in-valencia.jpg", // El Carmen District
    alt: "El Carmen District",
  },
];

export const PartnerImageList = [
  // { id: 1, name: one },
  { id: 2, name: two },
  { id: 3, name: three },
  // { id: 4, name: four },
  { id: 5, name: five },
  { id: 6, name: six },
  { id: 7, name: seven },
  { id: 8, name: eight },
  { id: 9, name: nine },
  // { id: 10, name: ten },
];

//Specific person info------------------------------------------

//EPM------------------------------------------


export const visit_places = [
  {
    name: "Serranos Towers",
    image:
      "https://images.pexels.com/photos/24906254/pexels-photo-24906254/free-photo-of-medieval-serranos-towers-in-valencia.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "2.4",
  },
  {
    name: "Valencia Cathedral",
    image:
      "https://images.pexels.com/photos/21287065/pexels-photo-21287065/free-photo-of-basilica-de-la-mare-deu-dels-desemparats-and-cathedral-in-valencia.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "3.6",
  },
  {
    name: "Gulliver park",
    image:
      "https://images.pexels.com/photos/31978874/pexels-photo-31978874/free-photo-of-tranquil-park-scene-with-fountain-and-trees.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "4.7",
  },
  {
    name: "Oceanogràfic València",
    image:
      "https://images.pexels.com/photos/256150/pexels-photo-256150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "6",
  },
  {
    name: "Ciudad de las Artes y las Ciencias",
    image:
      "https://images.pexels.com/photos/6237137/pexels-photo-6237137.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    km: "6.5",
  },
];
